import type {
  AgentBlueprint,
  AgentDetail,
  AgentListItem,
  CreateAgentInput,
  GenerateBlueprintInput,
  SkillListItem,
  UpdateAgentInput,
  UpdateAgentSkillsInput,
} from '@qualibot/shared';
import { api } from './api-client';

export async function listAgents(): Promise<AgentListItem[]> {
  const { data } = await api.get<{ items: AgentListItem[] }>('/api/agents');
  return data.items;
}

export async function fetchAgent(id: string): Promise<AgentDetail> {
  const { data } = await api.get<AgentDetail>(`/api/agents/${id}`);
  return data;
}

export async function generateBlueprint(input: GenerateBlueprintInput): Promise<AgentBlueprint> {
  const { data } = await api.post<{ blueprint: AgentBlueprint }>(
    '/api/agents/generate-blueprint',
    input,
  );
  return data.blueprint;
}

export async function createAgent(input: CreateAgentInput): Promise<AgentDetail> {
  const { data } = await api.post<AgentDetail>('/api/agents', input);
  return data;
}

export async function updateAgent(id: string, input: UpdateAgentInput): Promise<AgentDetail> {
  const { data } = await api.put<AgentDetail>(`/api/agents/${id}`, input);
  return data;
}

export async function deleteAgent(id: string): Promise<void> {
  await api.delete(`/api/agents/${id}`);
}

export async function updateAgentSkills(
  id: string,
  input: UpdateAgentSkillsInput,
): Promise<AgentDetail> {
  const { data } = await api.put<AgentDetail>(`/api/agents/${id}/skills`, input);
  return data;
}

export async function listSkills(): Promise<SkillListItem[]> {
  const { data } = await api.get<{ items: SkillListItem[] }>('/api/skills');
  return data.items;
}
